import { render, staticRenderFns } from "./NoticeBoardWidget.vue?vue&type=template&id=4e4ce314&scoped=true"
import script from "./NoticeBoardWidget.vue?vue&type=script&lang=js"
export * from "./NoticeBoardWidget.vue?vue&type=script&lang=js"
import style0 from "./NoticeBoardWidget.vue?vue&type=style&index=0&id=4e4ce314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ce314",
  null
  
)

export default component.exports